<div class="tree-search-input with-ng-select">
  <label>Hersteller</label>
  <ng-select  [items]="makes" #makeSelect
              placeholder="Suche"
              bindLabel="display"
              bindValue="value"
              [notFoundText]="notFoundText"
              [compareWith]="compareManufacturer"
              [selectOnTab]="true"
              (ngModelChange)="updateMainTypes()"
              [(ngModel)]="vehicleIdentification.manufacturer">
  </ng-select>
  <br/>
  <label>Haupttyp</label>
  <ng-select  [items]="mainTypes" #mainTypeSelect
              placeholder="Suche"
              bindLabel="display"
              bindValue="value"
              [notFoundText]="notFoundText"
              [selectOnTab]="true"
              (ngModelChange)="onMainTypeChange()"
              [compareWith]="compareMainType"
              [(ngModel)]="vehicleIdentification.mainType">
  </ng-select>
</div>
